/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { LocalStorageService } from "./services/local-storage.service";
import { UnidadeService } from "./services/unidade.service";

@Component({
  selector: "ngx-app",
  template: `
    <router-outlet></router-outlet>
    <ngx-spinner
      [fullScreen]="true"
      type="ball-clip-rotate-multiple"
      size="medium"
    >
      <p style="font-size: 20px; color: white">Carregando...</p>
    </ngx-spinner>
  `,
})
export class AppComponent implements OnInit {
  constructor(
    public spinner: NgxSpinnerService,
    private unidadeService: UnidadeService,
    private storage: LocalStorageService
  ) {}

  ngOnInit() {
    this.unidadeService
      .getEntidadeById(this.storage.get("entidade"))
      .subscribe((response) => {
        this.storage.set("corHeader", response.corHeader);
        this.storage.set("logo", response.logo);
      });
    // this.spinner.show();

    // setTimeout(() => {
    //   /** spinner ends after 5 seconds */
    //   this.spinner.hide();
    // }, 500);
  }
}
